export default __webpack_public_path__ + "static/person-eu-c04a9ec6fd5a63e78d9a3b9df9a4a949.svg";